import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Credit } from '../../../models/credit';

@Component({
  selector: 'app-pack',
  templateUrl: './pack.component.html',
  styleUrls: ['./pack.component.scss'],
})
export class PackComponent {
  @Input() pack!: Credit.Pack;

  @Output() packSelected = new EventEmitter<Credit.Pack>();

  selectPack(): void {
    this.packSelected.emit(this.pack);
  }
}
